import { PrismEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { TouchPointHelper } from '../../helpers/touchPointHelper';

const prismEngineConfigs: PrismEngineConfigs = {
	uiElementsByName: TouchPointHelper.getUiElementsByName(),
};

export default prismEngineConfigs;
